import { SegmentedControlOption } from 'ui/segmentedControl';
import { displayContent } from '../common';

export const DISPLAY_CONTENT = {
  settings: {
    actionButtonCloseMessageTooltipContent:
      "Message will close for the entirety of run time, regardless of the user's elegibility status.",
    actionButtonCreateButton: 'Add action button',
    actionButtonDefaultTitle: 'New button',
    actionButtonIdentifierHelpText: 'Used to identify the button for event tracking.',
    actionButtonIdentifierLabel: 'Identifier',
    actionButtonIdentifierPlaceholder: 'newButton',
    actionButtonInputsLabel: 'Button action',
    actionButtonTypeClose: 'Close message',
    actionButtonTypeCustom: 'Custom action',
    actionButtonTypeUrl: 'Open URL',
    behaviorHeader: 'Behavior',
    contentHeader: 'Content',
    customActionErrorText:
      'Must be a URL with https://, a handlebar, or an Iterable action protocol (for example, action:// or iterable://)',
    customTextFieldsAddButtonLabel: 'Add custom text field',
    customTextFieldsDefaultLabel: 'New field',
    customTextFieldsHeader: 'Custom text fields',
    detailsHeader: displayContent.headerDetails,
    emptyInputText: 'None',
    formActionButtonsLabel: 'Action buttons',
    formAlertTypeLabel: 'Alert type',
    formBackgroundColorLabel: 'Background color',
    formBodyLabel: 'Body',
    formMediaUrlLabel: 'Media URL',
    formOpenActionLabel: 'Open action',
    formTitleLabel: 'Title',
    openActionCustomHelpText: 'Custom action handler defined in the mobile app.',
    openActionTypeCustom: 'Custom action',
    openActionTypeNone: 'None',
    openActionTypeUrl: 'Open URL',
    openActionUrlHelpText: 'Typically a deeplink URL.',
    urlHandlebarErrorText: 'Invalid handlebars',
    urlHttpsErrorText: 'Must start with https://',
    urlInvalidErrorText: 'Invalid URL',
    urlPlaceholder: 'https://www.example.com',
  },
  preview: {
    emptyPreview: 'To preview your embedded message, go to Edit details and begin adding content',
    headerLabel: 'Design',
    previewInfo:
      'Preview only. Actual display depends on your app’s implementation. Please display a test message for an accurate preview.',
  },
};

export enum Platform {
  MOBILE = 'embedded-platform-mobile',
  DESKTOP = 'embedded-platform-desktop',
}

export const PLATFORM_OPTIONS: SegmentedControlOption[] = [
  { key: Platform.MOBILE, name: 'Mobile', value: Platform.MOBILE },
  { key: Platform.DESKTOP, name: 'Desktop', value: Platform.DESKTOP },
];

export enum EmbeddedOpenAction {
  NONE = 'none',
  URL = 'openUrl',
  CUSTOM = 'customAction',
}

export enum EmbeddedActionButton {
  URL = 'openUrl',
  CLOSE = 'closeMessage',
  CUSTOM = 'customAction',
}
